module.exports = __webpack_public_path__ + "img/ss_blue-10.d2bd1ca5.jpg";